export const mergeGravityFormState = (rootStore, props) => {
    mergePropsState(rootStore, props);
};
const mergePropsState = (rootStore, props) => {
    if (props.language && props.language !== rootStore.propStateStore.currentLanguage) {
        rootStore.propStateStore.setCurrentLanguage(props.language);
    }
    if (props.env && props.env !== rootStore.propStateStore.env) {
        rootStore.propStateStore.setEnv(props.env);
    }
    if (props.decodedParams && props.decodedParams !== rootStore.propStateStore.decodedParams) {
        rootStore.propStateStore.setDecodedParams(props.decodedParams);
    }
    if (props.navigate && props.navigate !== rootStore.propStateStore.navigate) {
        rootStore.propStateStore.setNavigate(props.navigate);
    }
    if (props.clientAuth !== rootStore.propStateStore.clientAuth) {
        rootStore.propStateStore.setClientAuth(props.clientAuth);
    }
    if (props.pathname && props.pathname !== rootStore.propStateStore.pathname) {
        rootStore.propStateStore.setPathname(props.pathname);
    }
    if (props.cmsData && props.cmsData !== rootStore.cmsDataStore.data) {
        rootStore.cmsDataStore.setAllData(props.cmsData);
    }
};
//# sourceMappingURL=GravityFormStateMergeUtil.js.map